import { Component, OnInit, ViewChild } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material'
import { ActivatedRoute } from '@angular/router'
import { fuseAnimations } from '../../../../../core/animations'
import { DocumentModel } from '../../models/document-model'
import { AdminDocumentsService } from '../../services/admin-documents.service'

@Component({
  selector: 'app-admin-document-list',
  templateUrl: './admin-document-list.component.html',
  styleUrls: ['./admin-document-list.component.scss'],
  animations: fuseAnimations,
})
export class AdminDocumentListComponent implements OnInit {
  searchInput: string
  documents: DocumentModel[]
  currentDocument: DocumentModel
  onFilterChanged: Subscription
  onDocumentChanged: Subscription
  limit = 10
  pageIndex = 0
  totalResults: number
  displayedColumns = ['name', 'status', 'laynthe', 'invoice_type', 'created_on']
  dataSource: any
  isLoading = false
  administrationId: number

  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatSort) sort: MatSort

  constructor(private adminDocumentService: AdminDocumentsService, private route: ActivatedRoute) {
    this.administrationId = this.route.snapshot.params['administrationId']
  }

  ngOnInit() {
    this.sort.sortChange.subscribe(() => {
      this.adminDocumentService.changeSort(this.sort)
      this.paginator.pageIndex = 0
    })

    this.onFilterChanged = this.adminDocumentService.onFilterChanged
      .do(() => (this.isLoading = true))
      .switchMap(data => {
        return this.adminDocumentService.list(this.administrationId)
      })
      .map(results => {
        this.totalResults = results.total_results
        this.documents = results.rows
        this.dataSource = new MatTableDataSource(this.documents)
        this.adminDocumentService.onDocumentsChanged.next(results)
      })
      .do(() => (this.isLoading = false))
      .subscribe()

    this.onDocumentChanged = this.adminDocumentService.onDocumentChanged.subscribe(document => {
      if (document == undefined) {
        this.displayedColumns = ['name', 'status', 'lyanthe', 'invoice_type', 'created_on']
      } else {
        this.displayedColumns = ['name', 'status']
      }
      this.currentDocument = document
    })
  }

  ngOnDestroy() {
    this.onFilterChanged.unsubscribe()
    this.onDocumentChanged.unsubscribe()
  }

  /**
   * @param {DocumentModel} document
   */
  readUser(document: DocumentModel) {
    this.adminDocumentService.setCurrentDocument(document)
  }

  sortData(sort: MatSort) {
    this.adminDocumentService.changeSort(sort)
  }

  getPage(event) {
    this.adminDocumentService.changeFilter(event)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/admin-documents/admin-document-list/admin-document-list.component.ts